<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />

      </div>
      <TableControlShowClearn v-model="filter.status"></TableControlShowClearn>
      <button class="btn btn-primary w-88px" @click="getAkamaiList">搜尋</button>
    </div>

    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiChangeStatus(true)">清除快取</button>
          </div>
        </div>
        <tr>
          <th class="text-left">拖曳</th>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left">Cache Tag</th>
          <th class="text-left">Cache key</th>
          <th class="text-left">Do action</th>
          <th class="text-left">Do action</th>
          <th class="text-left">count Total</th>
        </tr>
        </thead>
        <!-- <tbody> -->
        <draggable v-model="localAkamaiList" tag="tbody" @end="onDragEnd">
          <tr
            v-for="item in localAkamaiList"
            :key="item.id"
          >
            <td>
                <v-icon style="cursor:grab">mdi-drag</v-icon>
            </td>
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>{{ item.key }}</td>
            <td>{{ item.cache_key }}</td>
            <td v-if="item.do_action =='flush'">{{ item.do_action }}</td>
            <td v-else>cleaned</td>
            <td class="col-icon">
              <button v-if="item.do_action" class="btn square" @click="toggleStatus(item.id)">
                <v-icon color="warning-500">star</v-icon>
              </button>
            </td>
            <td>{{ item.fun_count }}</td>

          </tr>
        </draggable>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getAkamaiList" model="akamai"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import TableControlShowClearn from '@/components/TableControlShowClearn.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    SimpleSelectWithSearchInput,
    TableControlShowClearn,
    FormSwitch,
    Pagination,
    deleteDialog,
    draggable
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
    localAkamaiList:[]
  }),
  created() {
    this.localAkamaiList = [...this.akamaiList];
  },
  computed: {
    ...mapState('akamai', ['akamaiList', 'filter']),
    ...mapGetters(['local', 'lang']),
    lengthOfisCheckedList() {
      return this.akamaiList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.akamaiList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.akamaiList.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.akamaiList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.akamaiList.length) {
        this.checkAllStatus = true;
      }
    },
    akamaiList(dataList){
      this.localAkamaiList = [...dataList];
    }
  },
  methods: {
    ...mapActions('akamai', {
      getAkamaiList: 'find',
      destroyNews: 'destroy',
      clear: 'clear',
      changeIsTop: 'changeIsTop',
      changeStatus: 'clearAkamaiCache',
      changeIsShowOnHomepge: 'changeIsShowOnHomepge',
    }),
    toNewsEdit(id) {
      this.$router.push({
        name: 'NewsEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.akamaiList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.akamaiList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyNews(id).then(() => {
        this.getAkamaiList();
      });
    },
    onDragEnd() {
      //  console.log('新順序：', this.localAkamaiList);
      //  console.log('data', this.$store.state.akamai.meta);

      // 拖曳結束後傳送資料給store
      this.$store.dispatch('akamai/saveBulk', {
        drangEndData: this.localAkamaiList,
        module:"Akamai_Cache",
        ...this.$store.state.akamai.meta
      });
    },
    async multiChangeStatus(status) {
      
      await this.changeStatus({
        ids:this.isCheckedListIds
      }).then(() => {
      });
      // await this.isCheckedListIds.forEach((id) => {
      //   this.changeStatus({
      //     id, status,
      //   }).then(() => {});
      // });
      this.getAkamaiList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getAkamaiList();
      });
    },
    toggleIsShowOnHomePage(id) {
      this.changeIsShowOnHomepge(id).then(() => {
        this.getAkamaiList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-news-title {
    width: 390px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-tab {
    width: 130px;
    margin-right: 10px;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
